import service from "@/utils/request"

export function getListApi(params) {
    return service({
        url: "/cashOut/getList",
        method: "get",
        params
    })
}
export function updateStatusApi(data) {
    return service({
        url: "/cashOut/updateStatus",
        method: "post",
        data
    })
}